import { render, staticRenderFns } from "./carouselImg.vue?vue&type=template&id=0ea7f7c0&scoped=true"
import script from "./carouselImg.vue?vue&type=script&lang=js"
export * from "./carouselImg.vue?vue&type=script&lang=js"
import style0 from "./carouselImg.vue?vue&type=style&index=0&id=0ea7f7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7f7c0",
  null
  
)

export default component.exports